import React from "react";
import { Notification } from "../";
import styles from "./NotificationContainer.module.css";

const NotificationContainer = ({ notifications, onRemoveNotification }) => {
	if (!notifications || notifications.length === 0) return null;

	return (
		<div className={styles.notificationContainer}>
			{notifications.map((notification) => (
				<div key={notification.id} className={styles.notificationWrapper}>
					<Notification
						type={notification.type}
						message={notification.message}
						onClose={() => onRemoveNotification(notification.id)}
					/>
				</div>
			))}
		</div>
	);
};

export default NotificationContainer;
